'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindShortcuts = undefined;

var _mousetrap = require('mousetrap');

var _mousetrap2 = _interopRequireDefault(_mousetrap);

var _undoRedoActions = require('../undoRedo/undoRedoActions');

var _elementShortcutActions = require('../../element/elementShortcutActions');

var _timeUtil = require('../../../common/utils/timeUtil');

var _selectionActions = require('../../element/selection/selectionActions');

var _inboxActions = require('../../inbox/inboxActions');

var _keyConstants = require('./keyConstants');

var _cardConstants = require('../../../common/cards/cardConstants');

var _boardConstants = require('../../../common/boards/boardConstants');

var _columnConstants = require('../../../common/columns/columnConstants');

var _imageConstants = require('../../../common/images/imageConstants');

var _linkConstants = require('../../../common/links/linkConstants');

var _inboxConstants = require('../../inbox/inboxConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var undo = function undo(dispatch, props) {
    return dispatch((0, _undoRedoActions.undoAction)());
};
var redo = function redo(dispatch, props) {
    return dispatch((0, _undoRedoActions.redoAction)());
};
var deselect = function deselect(dispatch, props) {
    return dispatch((0, _selectionActions.deselectAllElements)());
};
var fakeSave = function fakeSave(dispatch, props) {
    return dispatch({ type: 'FAKE_SAVE', sync: true, modified: (0, _timeUtil.getTimestamp)() });
};

var newCard = function newCard(dispatch, props) {
    return dispatch((0, _elementShortcutActions.createNewElement)(_cardConstants.CARD_TYPE, props));
};
var newBoard = function newBoard(dispatch, props) {
    return dispatch((0, _elementShortcutActions.createNewElement)(_boardConstants.BOARD_TYPE, props));
};
var newColumn = function newColumn(dispatch, props) {
    return dispatch((0, _elementShortcutActions.createNewElement)(_columnConstants.COLUMN_TYPE, props));
};
var newImage = function newImage(dispatch, props) {
    return dispatch((0, _elementShortcutActions.createNewElement)(_imageConstants.IMAGE_TYPE, props));
};
var newLink = function newLink(dispatch, props) {
    return dispatch((0, _elementShortcutActions.createNewElement)(_linkConstants.LINK_TYPE, props));
};

var moveToTrash = function moveToTrash(dispatch, props) {
    return dispatch((0, _elementShortcutActions.moveElementToTrash)(props));
};
var toggleUnsorted = function toggleUnsorted(dispatch, props) {
    if (!props.currentBoard) return;
    if (props.currentBoard.getIn(['content', 'inbox']) === _inboxConstants.INBOX_STATE.OPEN) {
        return dispatch((0, _inboxActions.closeInbox)({ id: props.currentBoardId }));
    }
    dispatch((0, _inboxActions.openInbox)({ id: props.currentBoardId }));
};

var bindShortcuts = exports.bindShortcuts = function bindShortcuts(dispatch) {
    var boundkeys = [];
    var props = {};

    var bind = function bind(keycode, dispatchAction) {
        boundkeys.push(keycode);
        _mousetrap2.default.bind(keycode, function (event) {
            event.preventDefault();
            dispatchAction(dispatch, props);
        });
    };

    var bindGlobal = function bindGlobal(keycode, dispatchAction) {
        boundkeys.push(keycode);
        (0, _mousetrap2.default)(document.body).bind(keycode, function (event) {
            event.preventDefault();
            dispatchAction(dispatch, props);
        });
    };

    var unbind = function unbind() {
        boundkeys.forEach(function (keycode) {
            _mousetrap2.default.unbind(keycode);
        });
    };

    var setProps = function setProps(p) {
        Object.assign(props, p);
    };

    // bind actions
    bind(_keyConstants.SHORTCUT_KEYS.UNDO, undo);
    bind(_keyConstants.SHORTCUT_KEYS.REDO, redo);

    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_CARD, newCard);
    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_BOARD, newBoard);
    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_COLUMN, newColumn);
    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_IMAGE, newImage);
    bindGlobal(_keyConstants.SHORTCUT_KEYS.NEW_LINK, newLink);

    bindGlobal(_keyConstants.SHORTCUT_KEYS.ESCAPE, deselect);
    bind(_keyConstants.SHORTCUT_KEYS.DELETE, moveToTrash);
    bind(_keyConstants.SHORTCUT_KEYS.TOGGLE_UNSORTED_NOTES, toggleUnsorted);

    bindGlobal(_keyConstants.SHORTCUT_KEYS.SAVE, fakeSave);

    return { unbind: unbind, setProps: setProps };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/keyboard/keyboardShortcuts.js
// module id = 2127
// module chunks = 0